<template>
	<transition name="chartcontainer">
		<div class="chartcontainer">
			<div class="close" @click="click"></div>
			<div id="chartContainer"></div>
		</div>
	</transition>
</template>
<script>
	import { performRequest }           from "../script/ws/wsclient";
	import { mapMutations, mapGetters } from "vuex";

	export default {
		name:     "ChartContainerDay",
		data() {
			return {
				chart: {}
			};
		},
		mounted() {
			( () => {
				let command   = {};
				let data      = {};
				let chartList = {};
				let chart;

				function onResponse(a, val) {
					let json = [];
					let tmp  = [];
					let t;

					a.data.forEach(item => {
						t       = {};
						t.label = item.stream;
						t.y     = item["leak_count"];
						tmp.push(t);
					});

					tmp.forEach(item => {
						if (item.y >= 5) {
							json.push(item);
						}
					});
					chartList[val].options.data[0].dataPoints = json;
					chartList[val].render();
				}

				function initGraph() {
					chart         = new CanvasJS.Chart("chartContainer", {
						zoomEnabled:     true,
						exportEnabled:   true,
						theme:           "dark2",
						width:           document.querySelector(".chartcontainer")
							                 .offsetWidth,
						height:
						                 document.querySelector(".chartcontainer").offsetWidth /
							                 2.3,
						title:           {
							text:      "Сыпуха каналов за сутки",
							fontSize:  14,
							fontColor: "black"
						},
						backgroundColor: "rgba(168, 153, 166, 0.9)",
						borderRadius:    5,
						axisX:           {
							labelAutoFit: false,
							labelAngle:   -45,
							interval:     1
						},
						axisY:           {
							title: ""
						},
						data:            [
							{
								type:         "column",
								bevelEnabled: true,
								indexLabel:   "{y}",
								dataPoints:   null
							}
						]
					});
					chart.name    = "day";
					chartList.day = chart;
				}

				function gistG(val, text, operator) {
					command.section = "iptvlog";
					command.name    = text;
					data.dateTo     = Math.floor(Date.now() / 1000);
					data.dateFrom   = Math.floor(Date.now() / 1000) - 60 * 60 * 24;
					data.operator   = operator;
					performRequest(command, data, a => {
						onResponse(a, val);
					});
				}

				gistG("day", "getStreamLeak", this.getViewUser);
				initGraph();
			} )();
		},
		computed: {
			...mapGetters(["getViewUser"])
		},
		methods:  {
			...mapMutations(["setChartContainerDay"]),
			click() {
				this.setChartContainerDay(false);
			}
		}
	};
</script>
<style scoped lang="scss">
	.chartcontainer {
		position: fixed;
		left: 50%;
		transform: translateX(-50%);
		margin-top: 4rem;
		padding-top: 3rem;
		width: 90%;
		background-color: rgba(168, 153, 166, 0.9);
		
		#chartContainer_day {
			background-color: rgba(145, 255, 230, 0.46);
			width: 90%;
			margin-left: 50%;
			transform: translateX(-50%);
		}
		
		.close {
			position: fixed;
			width: 25px;
			height: 25px;
			top: 5px;
			right: 5px;
			background: url('../../static/close.png') no-repeat;
			background-size: 100%;
			cursor: pointer;
		}
	}
	@media (max-width: 620px) {
		.chartcontainer {
			margin-top: 8rem;
		}
	}
	.chartcontainer-enter-active {
		transition: all 0.3s ease;
	}
	.chartcontainer-leave-active {
		transition: all 0.3s ease;
	}
	.chartcontainer-enter, .chartcontainer-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/ChartContainerDay.vue